import { render, staticRenderFns } from "./baseCost.vue?vue&type=template&id=2ada73be&scoped=true"
import script from "./baseCost.vue?vue&type=script&lang=js"
export * from "./baseCost.vue?vue&type=script&lang=js"
import style0 from "./baseCost.vue?vue&type=style&index=0&id=2ada73be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada73be",
  null
  
)

export default component.exports